import React from "react";
import { bind } from "decko";
import ImageSub from "../img/substitution.png";

/**
 * UI for selecting a player from a selected lineup
 */
export default class L1PlayerSelector extends React.Component {
    @bind
    selectPlayer (player) {
        if (this.props.player !== null && this.props.player.id === player.id) {
            player = null;
        }
        this.props.onChange(player);
    }

    render () {

        let disabledCheck;
        let inverted = this.props.invertUnavailable;
        if (!this.props.playersOnPitch || !this.props.playersUnavailable) {
            disabledCheck = () => false;
            inverted = true;
        } else if (inverted) {
            disabledCheck = (player) => {
                return (this.props.playersUnavailable.has(player.id) || this.props.playersOnPitch.has(player.id));
            }
        } else {
            disabledCheck = (player) => {
                return (this.props.playersUnavailable.has(player.id) || !this.props.playersOnPitch.has(player.id));
            }
        }

        const sortFunc = (a, b) => (disabledCheck(a) - disabledCheck(b)); // Note: It's already sorted by number

        // Show player lineup
        const players = this.props.lineup.playersToText(this.props.selectedTeam.name, false);
        players.sort(sortFunc);
        let curPlayerId = this.props.player === null ? null : this.props.player.id;
        let clsName = "table-options-item text-outline";

        let optionElements = players.map((player) => {
            const disabled = disabledCheck(player);
            let cls = clsName;
            if (player.id === curPlayerId) cls += " active";
            else if (disabled) cls += " disabled";
            let info = player.extraInfo || "";
            // TODO probably a cleaner method of tracking
            if (info === "SUB" && !inverted && !disabled)
                info = <img src={ImageSub} alt="" />;
            return (
                <td key={player.id}>
                    <a className={cls}
                       onClick={() => {
                           if (disabled) return;
                           return this.selectPlayer(player);
                       }}>
                        <span>{player.text}</span>
                        <span className="large-player-option-position-badge">{info}</span>
                    </a>
                </td>
            );
        });

        //Chunk options into rows
        const maxOptionsPerRow = Math.min(12, Math.ceil(players.length / 2));
        let optionRows = [];
        for (let i = 0; i < optionElements.length; i += maxOptionsPerRow) {
            optionRows.push(
                <tr key={i}>
                    {optionElements.slice(i, i + maxOptionsPerRow)}
                </tr>
            );
        }

        return (
            <table className="table table-sm table-options-container">
                <tbody>
                {optionRows}
                </tbody>
            </table>
        );
    }
}



// WEBPACK FOOTER //
// ./src/js/L1PlayerSelector.js